import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';


@Injectable()
export class TermsAndConditionsRouteGuard implements CanActivate {

    constructor(
        private currentUserStateService: CurrentUserStateService,
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserStateService.getState().pipe(filter(x => !!x),
            map(userState => {
                return !(userState?.account?.neptuneOnly && !userState?.preferences?.tosAccepted && !userState?.impersonator);
            }));
    }
}
